import { Action } from '@anm/components/ActionsDropdown';
import DownloadVideoAction from '@anm/components/dropdown-actions/downloadVideo';
import { getDropdownAction } from '@anm/helpers/dropdownActions';
import { useSelector } from 'react-redux';

import config from '../../../../config';
import { userSelectors } from '../../../../store/modules/user';

const { urls } = config();

type DownloadVideoActionProps = {
  canStreamVideo: boolean;
  projectId: string;
  streamId?: string | null;
  handler?: () => void;
};

const useDownloadVideoAction = ({ projectId, canStreamVideo, streamId, handler }: DownloadVideoActionProps) => {
  const publishUrl = `${urls.editor}/#p=${projectId}&target=publish`;
  const canUserDownloadVideo = useSelector(userSelectors.selectCanUserDownloadVideo);

  const isUpgradeTooltip = !canUserDownloadVideo && !streamId;
  const disabled = isUpgradeTooltip || !canStreamVideo;

  const action = getDropdownAction('onDownload');

  const downloadVideoAction: Action = {
    icon: action.icon,
    disabled,
    autoClose: !disabled,
    renderComponent: () => (
      <DownloadVideoAction {...{ action, handler, isUpgradeTooltip, canStreamVideo, publishUrl }} />
    )
  };

  return downloadVideoAction;
};

export default useDownloadVideoAction;
